export const QueryKeyEnum = {
  ASSESSMENT: {
    CLEAR_ANSWER: 'ASSESSMENT_CLEAR_ANSWER',
    DEFINITION: 'ASSESSMENT_DEFINITION',
    DEFINITION_UPLOAD: 'ASSESSMENT_DEFINITION_UPLOAD',
    DOWNLOAD: 'ASSESSMENT_DOWNLOAD',
    GENERATE_DRAFT: 'ASSESSMENT_GENERATE_DRAFT',
    GENERATE_FINAL_REPORT: 'ASSESSMENT_GENERATE_FINAL_REPORT',
    QUESTIONS: 'ASSESSMENT_QUESTIONS',
    REGENERATE: 'ASSESSMENT_REGENERATE',
    REPORT: 'ASSESSMENT_REPORT',
    REPORT_STATUS: 'ASSESSMENT_REPORT_STATUS',
    STATE: 'ASSESSMENT_STATE',
    SUBMIT_ANSWER: 'ASSESSMENT_SUBMIT_ANSWER',
    UPDATE_DEFINITION_STATUS: 'UPDATE_DEFINITION_STATUS',
    UPDATE_DRAFT: 'ASSESSMENT_UPDATE_DRAFT',
    UPDATE_STATUS: 'UPDATE_STATUS',
  },
  CANDIDATE_DETAILS: 'CANDIDATE_DETAILS',
  COMPANIES: {
    LIST: 'COMPANIES_LIST',
    LIST_FOR_VACANCY: 'COMPANIES_LIST_FOR_VACANCY',
  },
  COMPANY_DETAILS: 'COMPANY_DETAILS',
  COMPANY_EMPLOYEE_DETAILS: 'COMPANY_EMPLOYEE_DETAILS',
  COMPANY_OBSERVERS: 'COMPANY_OBSERVERS',
  COMPANY_OBSERVERS_ADD: 'COMPANY_OBSERVERS_ADD',
  COMPANY_OBSERVERS_REMOVE: 'COMPANY_OBSERVERS_REMOVE',
  CURRENT_USER: 'CURRENT_USER',
  DICTIONARIES: {
    ALL: 'DICTIONARIES_ALL',
    CREATE: 'DICTIONARIES_CREATE',
    GET: 'GET',
    OCD_LOCATIONS: 'DICTIONARIES_OCD_LOCATIONS',
    SEARCH_INFINITE: 'DICTIONARIES_SEARCH_INFINITE',
    TYPES: 'DICTIONARIES_TYPES',
    UPDATE: 'UPDATE',
  },
  ENV_CONFIG: 'ENV_CONFIG',
  GENERATE_PRESIGNED_URL: 'GENERATE_PRESIGNED_URL',
  LOCATION_CODES: 'LOCATION_CODES',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  PROFILE_BUNDLE_CREATE: 'PROFILE_BUNDLE_CREATE',
  PROFILE_BUNDLE_DELETE: 'PROFILE_BUNDLE_DELETE',
  PROFILE_BUNDLE_DETAILS: 'PROFILE_BUNDLE_DETAILS',
  PROFILE_BUNDLE_DOWNLOAD: 'PROFILE_BUNDLE_DOWNLOAD',
  PROFILE_BUNDLE_PROFILE_ADD: 'PROFILE_BUNDLE_PROFILE_ADD',
  PROFILE_BUNDLE_PROFILE_REMOVE: 'PROFILE_BUNDLE_PROFILE_REMOVE',
  PROFILE_BUNDLE_PROFILES_GET: 'PROFILE_BUNDLE_PROFILES_GET',
  PROFILE_BUNDLE_UPDATE: 'PROFILE_BUNDLE_UPDATE',
  PROFILE_BUNDLE_USER_ACCESS_ADD: 'PROFILE_BUNDLE_USER_ACCESS_ADD',
  PROFILE_BUNDLE_USER_ACCESS_REMOVE: 'PROFILE_BUNDLE_USER_ACCESS_REMOVE',
  PROFILE_BUNDLE_USERS_ACCESS_GET: 'PROFILE_BUNDLE_USERS_ACCESS_GET',
  PROFILE_BUNDLES_GET: 'PROFILE_BUNDLES_GET',
  PROJECTS: {
    ALL: 'PROJECTS_ALL',
    ARCHIVE: 'PROJECT_ARCHIVE',
    DETAILS: 'PROJECT_DETAILS',
    EXISTS: 'PROJECT_EXISTS',
  },
  SESSION: 'SESSION',
  USER_PROFILE: {
    ALL: 'USER_PROFILE',
    CERTIFICATES: 'USER_PROFILE_CERTIFICATES',
    DEFAULT_LANGUAGE: 'USER_PROFILE_DEFAULT_LANGUAGE',
    DOWNLOAD_JSON: 'USER_PROFILE_DOWNLOAD_JSON',
  },
  USER_PROFILE_CV_DATA_REQUEST: 'USER_PROFILE_CV_DATA_REQUEST',
  USER_PROFILE_SEARCH_FULL_TEXT: 'USER_PROFILE_SEARCH_FULL_TEXT',
  USER_PROFILE_SEARCH_INFINITE: 'USER_PROFILE_SEARCH_INFINITE',
  USER_PROFILE_SEARCH_REGULAR: 'USER_PROFILE_SEARCH_REGULAR',
  USER_PROFILE_SEARCH_REQUIREMENTS: 'USER_PROFILE_SEARCH_REQUIREMENTS',
  USER_PROFILE_UPDATE_ACTIVE: 'USER_PROFILE_UPDATE_ACTIVE',
  USERS: {
    COMPANY_DATA: 'USER_COMPANY_DATA',
    COMPANY_EMPLOYEE: 'USER_COMPANY_EMPLOYEE',
    LANDING_PAGE: 'USER_LANDING_PAGE',
    SAVE_TOURS: 'USER_SAVE_TOURS',
    TOURS: 'USER_TOURS',
  },
  USERS_ROLES: 'USERS_ROLES',
  USERS_SHORT: 'USERS_SHORT',
  VACANCIES: {
    CREATE: 'VACANCY_CREATE',
    DASHBOARD: 'VACANCIES_DASHBOARD',
    DETAILS: 'VACANCY',
    PROJECTS: 'VACANCY_PROJECTS',
    UPDATE: 'VACANCY_UPDATE',
  },
  VACANCY_CANDIDATES: {
    ALL: 'VACANCY_CANDIDATES_ALL',
    CREATE: 'VACANCY_CANDIDATES_CREATE',
    STATUS_UPDATE: 'VACANCY_CANDIDATES_STATUS_UPDATE',
    UPDATE: 'VACANCY_CANDIDATES_UPDATE',
  },
  VACANCY_DETAILS: 'VACANCY_DETAILS',
} as const;
